<section class="verification p-0 reset-password-sidenav-content" fxLayout="column" fxLayoutAlign="start stretch">
  <!-- Step 1: Enter phone -->
  <ng-container *ngIf="step === 'enter_phone'">
    <h1>{{ 'RESET_PASSWORD' | translate }}</h1>
    <p>{{ 'ENTER_PHONE_NUMBER_DESC' | translate }}</p>

    <form
      class="reset-password-form sign-up-form"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      fxLayout="column"
      fxLayoutAlign="start stretch"
    >
      <div fxLayout="column" fxLayoutAlign="start stretch" class="field-group">
        <mat-label class="label">{{ 'AUTH.PHONE_NUMBER' | translate }}</mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            [placeholder]="'ENTER_PHONE_NUMBER' | translate"
            formControlName="MobileNumber"
            [maxLength]="12"
            appNumberOnly
          />
          <mat-error>
            <app-error-form
              [name]="'PHONE_NUMBER'"
              [control]="form.controls['MobileNumber']"
              [maxLength]="12"
              [minLength]="4"
            ></app-error-form>
          </mat-error>
        </mat-form-field>
      </div>

      <button
        type="submit"
        class="confirm-btn"
        [disabled]="form.invalid || loading"
      >
        <span>{{ 'RESET_PASSWORD' | translate }}</span>
        <span class="btn-spinner-icon" *ngIf="loading"></span>
      </button>
    </form>
    <app-verify-identity
      [showPhoneNumber]="true"
      [inlineMode]="true"
      [inlineUser]="mobileNumber"
      [canChangeVerifyType]="true"
      (backToVerification)="onVerifyTypeChange($event)"
    ></app-verify-identity>
  </ng-container>

  <!-- Step 2: Enter OTP -->
  <ng-container *ngIf="step === 'enter_otp'">
    <h1>{{ 'Verification_Code' | translate }}</h1>
    <p>{{ otpStepMessageKey | translate:{ number: submittedMobileNumber } }}</p>

    <ng-otp-input
      class="custom-otp-inputs mt-3"
      [config]="otpInputConfig"
      (onInputChange)="onOtpInputChange($event)"
    ></ng-otp-input>

    <button
      type="button"
      class="confirm-btn mt-3"
      [disabled]="!otpCode || otpCode.length !== 4 || confirmLoading"
      (click)="onConfirmOtp()"
    >
      <span>{{ 'Confirm' | translate }}</span>
      <span class="btn-spinner-icon" *ngIf="confirmLoading"></span>
    </button>
  </ng-container>

  <!-- Step 3: Enter new password -->
  <ng-container *ngIf="step === 'enter_new_password'">
    <h1>{{ 'UPDATE_YOUR_PASSWORD' | translate }}</h1>
    <p>{{ 'NEW_PASSWORD_SHOULD_BE_DIFFERENT' | translate }}</p>

    <form
      class="reset-password-form sign-up-form"
      [formGroup]="form"
      (ngSubmit)="onSubmitNewPassword()"
      fxLayout="column"
      fxLayoutAlign="start stretch"
    >
      <div fxLayout="column" fxLayoutAlign="start stretch" class="field-group">
        <mat-label class="label">{{ 'PASSWORD' | translate }}</mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            formControlName="newPassword"
            [placeholder]="'ENTER_PASSWORD' | translate"
            [maxLength]="20"
          />
          <button
            mat-icon-button
            matSuffix
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'"
            type="button"
          >
            @if (hidePassword) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-eye-slash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                />
                <path
                  d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                />
              </svg>
            }
            <!-- <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon> -->
          </button>
          <mat-error>
            <app-error-form
              [name]="'PASSWORD'"
              [control]="form.controls['newPassword']"
              [maxLength]="20"
              [minLength]="6"
            ></app-error-form>
          </mat-error>
        </mat-form-field>
      </div>

      <button
        type="submit"
        class="confirm-btn"
        [disabled]="form.get('newPassword')?.invalid || loading"
      >
        <span>{{ 'Confirm' | translate }}</span>
        <span class="btn-spinner-icon" *ngIf="loading"></span>
      </button>
    </form>
  </ng-container>
</section>
